import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  display: inline-block;
`;

export const Label = styled.p`
  font-size: 85.71%;
  color: #999999;
  opacity: 0.8;
  margin-bottom: ${grid.xs};
`;

export const ValueContent = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: ${grid.xs};

  img,
  svg {
    width: 16px;
    height: auto;
  }

  span {
    color: #4d4d4d;
    font-size: 100%;
  }
`;
